export const powerBIEmbedTokenLifetime = 1000 * 60 * 50 // 50 minutes
